import { render } from "./PageTitleComponent.vue?vue&type=template&id=75b37ccd&ts=true"
import script from "./PageTitleComponent?vue&type=script&lang=ts"
export * from "./PageTitleComponent?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/atlantis/atlantis/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__